(() => {
  document.querySelectorAll('[data-srv-share]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const share = root.querySelector('[data-srv-share-button]');
    const copy = root.querySelector('[data-srv-copy-button]');
    const status = root.querySelector('[data-srv-share-status]');
    if (navigator.share) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        try { await navigator.share({title: root.dataset.title, url: root.dataset.url}); }
        catch (error) { if (error.name !== 'AbortError') status.textContent = 'Please use Copy link or Share by email.'; }
      });
    }
    if (navigator.clipboard && window.isSecureContext) {
      copy.hidden = false;
      copy.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(root.dataset.url); status.textContent = 'Link copied.'; }
        catch { status.textContent = 'Please use Share by email.'; }
      });
    }
  });
})();
